import { gql } from '@apollo/client';

export const STANDORTGRUPPE_BY_ID = gql(`
  query rotationsplan_standortgruppeById($standortGruppenId: String!) {
   mitarbeiter_standortgruppeById(standortGruppenId: $standortGruppenId) {
      id
      rotationsplanEinstellungen {
        istRotationsplanAktiviert
      } 
      standorte {
        id
        name
      }
    }
  }
`);
